module.exports = __webpack_public_path__ + "img/uparrow-a79e6f71.svg";